import { useState, useEffect } from 'react';

/** Returns the current inner width of the window. Updates on resize. */
export function useWindowWidth(): number {
    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1200
    );
    useEffect(() => {
        const handler = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handler, { passive: true });
        return () => window.removeEventListener('resize', handler);
    }, []);
    return width;
}

/** Returns true when viewport width is ≤ breakpoint (default 768). */
export function useMobile(breakpoint = 768): boolean {
    return useWindowWidth() <= breakpoint;
}

/** Returns true when viewport width is ≤ breakpoint (default 1024). */
export function useTablet(breakpoint = 1024): boolean {
    return useWindowWidth() <= breakpoint;
}
